<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { setContext } from "svelte"
  import Recognition from "./Recognition.svelte"
  import { xhr } from "$app/utils"
  import { ChevronLeft } from "lucide-svelte"
  import Honeybadger from "$app/utils/honeybadger"

  interface Props {
    recognition: RecognitionType
    plan: any
    users: any
    external_recipients: any
    readOnly?: boolean
    current_user: any
    notification_id?: any
  }

  let props = $props()
  let {
    recognition,
    plan,
    users,
    external_recipients,
    readOnly = true,
    current_user,
    notification_id = null
  }: Props = props

  setContext("users", users)
  setContext("external_recipients", external_recipients)
  setContext("current_user", current_user)

  if (notification_id) {
    loadNotification()
  }

  async function loadNotification(): Promise<void> {
    try {
      const resp = await xhr.get(`/api/v1/notifications/${notification_id}`)
      let notification = resp.data.notification
      if (notification.type === "RecognitionCommentNotifier") {
        recognition.comments = recognition.comments.map((r) => {
          if (notification.params.recognition_comment.id === r.id) {
            return { ...r, _marked: true }
          } else {
            return { ...r, _marked: false }
          }
        })
      }
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
    }
  }
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 pb-8">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
      <h1 class="text-xl md:text-2xl lg:text-3xl">
        Building Our Culture and Practicing Gratefulness
      </h1>

      <div class="py-4">
        <a
          href="/plans/{plan.id}/recognitions"
          class="inline-flex bg-gray-100 py-2 px-4 rounded hover:shadow hover:bg-gray-50 hover:text-blue-800 text-gray-700 border border-gray-100 gap-1"
        >
          <ChevronLeft class="text-gray-500 size-6" />
          View All Recognitions
        </a>
      </div>
      <div class="flex w-100 lg:w-3/4 justify-center items-center mt-4">
        <ul class="gap-y-4 w-full">
          <Recognition {recognition} {readOnly} showComments={true} />
        </ul>
      </div>
    </div>
  </div>
</Layout>
